export default __webpack_public_path__ + "static/media/20210205_170511.490c3fa5.jpg";